import request from "@/utils/request.js"
// 获取配置项
export function getDictAPI(data){
  return request({
  	  method:'POST',
  	  url:'/api/dict',
  	  data:data
  })
}
// 提交
export function submit_shadow_gameAPI(data){
  return request({
  	  method:'POST',
  	  url:'/api/submit_shadow_game',
  	  data:data
  })
}
// 获取影赛下面的赛道
export function shadow_game_child_type_treeAPI(data){
  return request({
  	  method:'GET',
  	  url:'/api/shadow_game_child_type_tree',
  	  params:data
  })
}
// 获取隐私协议
export function agreementAPI(data){
  return request({
  	  method:'GET',
  	  url:'/api/agreement?key='+data,
  	  params:data
  })
}
// 上传
export function uploadAPI(data){
  return request({
  	  method:'POST',
  	  url:'/api/upload',
  	  data:data
  })
}
// 获取年级
export function get_grade_typeAPI(data){
  return request({
  	  method:'GET',
  	  url:'/api/get_grade_type',
  	  params:data
  })
}
// 获取报名渠道
export function get_source_typePI(data){
  return request({
  	  method:'GET',
  	  url:'/api/get_source_type',
  	  params:data
  })
}